import React, {
  useCallback,
  useState,
}                       from 'react';
import {
  ICreditUnion,
}                       from '@typings/accountManagement';
import {
  IComment,
  ICommentValues,
}                       from '@typings/comments';
import { ECommentType } from '@enums/common';
import {
  useSaveComment,
  useFetchComments,
  useFetchDocument,
}                       from '@modules/comments/queries/commentsQueries';
import { CommentsPage } from '../pages/CommentsPage';

interface IProps {
  push           : (path: string) => void;
  currentAccount : ICreditUnion;
  cuid           : string;
}

export const AccountCommentsContainer: React.FC<IProps> = ({
  push,
  currentAccount,
  cuid,
}) => {
  const [allComments, setAllComments] = useState<IComment[]>([]);

  // #region INTEGRATE | FETCH ALL COMMENTS
  useFetchComments({
    type : ECommentType.Account,
    id   : cuid,
  }, {
    enabled   : !!cuid,
    onSuccess : (commentsData: IComment[]) => {
      setAllComments(commentsData);
    },
  });
  // #endregion

  // #region INTEGRATE | API NEW COMMENT
  const { mutateAsync: saveComment } = useSaveComment({
    onSuccess: (data: IComment) => {
      setAllComments((prevState) => [data, ...prevState]);
    },
  });
  // #endregion

  // #region INTEGRATE | FETCH DOCUMENT
  const { mutateAsync: fetchDocument } = useFetchDocument();
  // #endregion

  const handleSaveComment = useCallback(
    async (comment: ICommentValues): Promise<void> => {
      await saveComment({
        type : ECommentType.Account,
        id   : currentAccount?.cuid ?? '',
        comment,
      });
    },
    [saveComment, currentAccount],
  );

  return (
    <CommentsPage
      push              = {push}
      comments          = {allComments}
      accountData       = {currentAccount}
      fetchDocument     = {fetchDocument}
      handleSaveComment = {handleSaveComment}
    />
  );
};
